import { render, staticRenderFns } from "./BackArrow.vue?vue&type=template&id=b95e870a&scoped=true&"
import script from "./BackArrow.vue?vue&type=script&lang=js&"
export * from "./BackArrow.vue?vue&type=script&lang=js&"
import style0 from "./BackArrow.vue?vue&type=style&index=0&id=b95e870a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95e870a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
